import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectLoading } from 'store/app/selectors';
import styles from './FullScreenLoader.module.scss';

const selectors = createStructuredSelector({
  loading: makeSelectLoading(),
} as any);

export const FullScreenLoader = () => {
  const { loading } = useSelector<any, any>(selectors);

  if (window.location.pathname === '/login') {
    return <div></div>;
  } else {
    return (
      <div className={`${styles.loading} ${loading ? styles.loadingShow : ''}`}>
        <div className={styles.loadingIcon}></div>
      </div>
    );
  }
};
